// extracted by mini-css-extract-plugin
export default {"header_side":"home_header_side__3wk5Y","header_right":"home_header_right__4+uAf","header_left":"home_header_left__iTFbZ","icon-tienngay":"home_icon-tienngay__KZ2UN"};